import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import { ShowIf } from 'components/utils';
import moment from 'moment';
import {ChiTietDoiTuongThanhTraDialog} from 'modules/dialog';
import { Dialog } from "@blueprintjs/core";
import { Input, DatePicker, TextArea} from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';
import { ThanhTra } from 'api';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import {get} from 'lodash';
import TextTruncate from 'react-text-truncate';

class RowItemDanhSachCuocThanhTraPage extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      chiTietDT: false,
      isOpen: false,
      listTaiLieuVanThuHuyCTT: [],
      dataFileDinhKem: {
        HuyCTT: []
      },
      ngayQuyetDinhHuyCTT: '',
      soCongVanHuyCTT: '',
      lyDoHuyCTT: '',
      keHoachThanhTraId: null,
      //Tài liệu đính kèm
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      dataTaiLieuVanThuDelete: [],
    }
  }

  closeDialog() {
    this.setState({
      isOpen: false
    });
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    if (type === 'HUY_CUOC_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;
      dataFileDinhKem.HuyCTT = data;
      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
  }

  onFileChangeDK(data) {
    let state = this.state;
    if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
      state.dsTaiLieuBoSung = data;
    } else {
      state.dsTepDinhKem = data;
    }
    this.setState(state);
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
        pass = validator.validate();
      else {
        validator.validate();
      }
    });

    return pass;
  }

  handleSave() {
    if (this.validateSubmitForm()) {
      let params = this.getParams();
      let idCTT = (this.props && this.props.item && this.props.item.cuocThanhTraId) ? this.props.item.cuocThanhTraId : null;
      ThanhTra.actions.deleteCuocThanhTraHuy.request({id: idCTT}, {params: params}).then(async (res) => {
        await Toastr(msg.huyCTT, 'success');
        await this.props.getList();
        await this.closeDialog();
        this.setState({
          ngayQuyetDinhHuyCTT: '',
          soCongVanHuyCTT: '',
          lyDoHuyCTT: '',
        });
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    };
  }

  createDSTepDinhKem(cuocId, keHoachId, data) {
    let listAddNew = [];
    data.forEach((item, i) => {
      let params = {
        cuocThanhTra: { id: parseInt(cuocId) },
        keHoachThanhTra: {id: keHoachId},
        loaiQuyTrinh: 'BOSUNG_THAYTHE_HUY_CUOC_THANH_TRA',
        buocGiaiQuyet: 'HUY_CUOC_THANH_TRA'
      }
      if (item.ten) {
        params.ten = item.ten;
        params.tenFileds = item.ten;
      }
      if (item.tenFile) {
        params.tenFile = item.tenFile;
      }
      if (item.duongDan) {
        params.duongDan = item.duongDan;
      }
      if (item.required) {
        params.required = true;
      }
      if (item.typeRequired) {
        params.typeRequired = item.typeRequired;
      }
      if (item.soQuyetDinh) {
        params.soQuyetDinh = item.soQuyetDinh;
      }
      if (item.ngayQuyetDinh) {
        params.ngayQuyetDinh = moment(item.ngayQuyetDinh).toISOString();
      }
      listAddNew.push(params);
    });

    if (listAddNew.length) {
      ThanhTra.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
    }
  }

  getParams() {
    let params = {};
    let khttId = this.props && this.props.item;
    if(this.state.id) {
      params = this.state.dataDetail;
    }

    params.lyDoHuyCTT = this.state.lyDoHuyCTT ? this.state.lyDoHuyCTT : '';

    params.ngayQuyetDinhHuyCTT = this.state.ngayQuyetDinhHuyCTT ? moment(this.state.ngayQuyetDinhHuyCTT).add( 7, 'hours').toISOString() : null;

    params.soCongVanHuyCTT = this.state.soCongVanHuyCTT ? this.state.soCongVanHuyCTT : '';
    if (khttId.keHoachThanhTraInfo && khttId.keHoachThanhTraInfo.keHoachThanhTraId) {
      params.keHoachThanhTraId = khttId.keHoachThanhTraInfo.keHoachThanhTraId ? khttId.keHoachThanhTraInfo.keHoachThanhTraId : null;
      this.createDSTepDinhKem(khttId.cuocThanhTraId, params.keHoachThanhTraId, this.state.dsTepDinhKem);
    }

    delete params['listTaiLieuVanThuHuyCTT'];

    return params;
  }

  handleChangeDate(name, e) {
    this.setState({
      [name]: e
    });
    this.handleChangeData();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
    this.handleChangeData();
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    });
  }

  showThoiHan() {
    let thoiHan = this.props.item.thoiHanThanhTraInfo;
    if (thoiHan != {}) {
      if (thoiHan.type == 'DAY') {

        if (thoiHan.value == 0) {
          return (
            <p style={{ color: "#E9573F" }}>Hết hạn</p>
          )
        } else if (thoiHan.value > 0) {
          return (
            <p>Còn {thoiHan.value} ngày</p>
          )
        } else {
          return (
            <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHan.value)} ngày</p>
          )
        }
      } else if (thoiHan.type == 'TIME') {
        return (
          <p style={{ color: "#E9573F" }}>Còn {thoiHan.value}</p>
        )
      }
    } else {
      return (
        <p/>
      )
    }
  }

  toggleDialog(status) {
    this.state.chiTietDT = status;
    this.setState({...this.state});
  }

  toggleDialogOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const {tienDoThanhTraInfo, loaiCuoc} = this.props.item;
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTrungUong = 19;
    let textTienDoThanhTra = '';
    if (userInfo.capCoQuanQuanLyId === TTTrungUong && get(tienDoThanhTraInfo, 'type') === "KET_THUC_THANH_TRA_TRUC_TIEP") {
      textTienDoThanhTra = 'Đang tiến hành';
    } else {
      textTienDoThanhTra = get(tienDoThanhTraInfo, 'text');
    }
    const textHoatDong = get(loaiCuoc, 'value') === 'KIEM_TRA' ? 'Kiểm tra' : 'Thanh tra'
    let Data = this.props.item || {};
    let countDT = Data && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length;
    // let tenNhieuDoiTuongThanhTra = Data.doiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo && Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text ? Data.doiTuongThanhTraInfo.loaiDoiTuongThanhTraInfo.text : Data.tenNhieuDoiTuongThanhTra;
    // let tenDoiTuongTheoKeHoach = Data.cuocThanhTraNhieuDoiTuong === false && Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 ? Data.listDoiTuongThanhTra[0].ten : tenNhieuDoiTuongThanhTra;

    return (
      <tr>
        <td>{this.props.count}</td>
        <td className='list-items-table'>
          <ul className="list-items-table">
            <li>
              <Link className='txt-underline txt-regular' style={{ color: '#208DF4' }} name='abc' onClick={this.toggleDialog.bind(this, true)}>{this.props.item.ten}</Link>
              <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={this.props.item} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this, false)} />
            </li>
            <li>{countDT} đối tượng</li>
          </ul>
        </td>
        <td className='list-items-table'>
          <ul className="list-items-table">
            <li>
              <ShowIf condition={this.props.item.hinhThucThanhTra !== 'THEO_KE_HOACH'}>
                <Link className='txt-underline txt-regular' style={{ color: '#208DF4' }} to={`/thanh-tra/chi-tiet-cuoc-thanh-tra/${this.props.item.cuocThanhTraId}`}>
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={get(this.props.item, 'noiDungThanhTra') || ''}
                  />
                </Link>
              </ShowIf>
              <ShowIf condition={this.props.item.hinhThucThanhTra === 'THEO_KE_HOACH'}>
                <Link className='txt-underline txt-regular' style={{ color: '#208DF4' }} to={`/thanh-tra/chi-tiet-cuoc-thanh-tra-ke-hoach/${this.props.item.cuocThanhTraId}`}>
                  <TextTruncate
                    line={3}
                    truncateText="…"
                    text={get(this.props.item, 'noiDungThanhTra') || ''}
                  />
                </Link>
              </ShowIf>
            </li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.hinhThucThanhTraInfo ? this.props.item.hinhThucThanhTraInfo.text : ''}</li>
            <li>{this.props.item.loaiHinhThanhTraInfo ? this.props.item.loaiHinhThanhTraInfo.text : ''}</li>
          </ul>
        </td>
        <td>{this.props.item.keHoachThanhTraSearchInfo && this.props.item.keHoachThanhTraSearchInfo.quyetDinhPheDuyetKTTT ? this.props.item.keHoachThanhTraSearchInfo.quyetDinhPheDuyetKTTT : ''}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.soQuyetDinhVeViecThanhTra ? this.props.item.soQuyetDinhVeViecThanhTra : ''}</li>
            <li>{this.props.item.ngayRaQuyetDinh ? moment(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.soKetLuanThanhTra ? this.props.item.soKetLuanThanhTra : ''}</li>
            <li>{this.props.item.soQuyetDinhXuLy ? this.props.item.soQuyetDinhXuLy : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.ngayHetHanThanhTra ? moment(this.props.item.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''}</li>
            <ShowIf condition = {this.props.item.chuyenTheoDoiThucHien !== true && this.props.item.tienDoThanhTra !== 'LUU_HO_SO'}>
              <li>{this.showThoiHan()}</li>
            </ShowIf>
          </ul>
        </td>
        <td>{textTienDoThanhTra}</td>
        <td>{textHoatDong}</td>
        <td>
          <ShowIf condition = {this.props.item.chuyenTheoDoiThucHien !== true && this.props.item.tienDoThanhTra != 'LUU_HO_SO'}>
            <div className="todo-wrap two-item">
              <ShowIf condition={this.props.item.keHoachThanhTraInfo == null}>
                <div className="wrap-link-todo">
                  <Link className="itt-edit" to={{pathname: `/thanh-tra/chinh-sua-cuoc-thanh-tra-dot-xuat/${this.props.item.cuocThanhTraId}`,state: {fromNotifications: false}}}>Chỉnh sửa</Link>
                </div>
              </ShowIf>
              <ShowIf condition={this.props.item.keHoachThanhTraInfo != null}>
                <div className="wrap-link-todo">
                  <Link className="itt-edit" to={{pathname: `/thanh-tra/chinh-sua-cuoc-thanh-tra/${this.props.item.cuocThanhTraId}`,state: {fromNotifications: false}}}>Chỉnh sửa</Link>
                </div>
              </ShowIf>
              {/* <ShowIf condition={this.props.item.keHoachThanhTraInfo !== null}>
                <div className="wrap-link-todo">
                  <Link className="itt-edit thaythe" to={{pathname: `/thanh-tra/thay-the-cuoc-thanh-tra/${this.props.item.cuocThanhTraId}`,state: {fromNotifications: true}}}>Thay thế</Link>
                </div>
                <ShowIf condition={this.props.item.hinhThucThanhTra === 'THEO_KE_HOACH'}>
                  <div className="wrap-link-todo">
                    <Link className="tt tt-bosungctt" to={{pathname:'/thanh-tra/them-moi-cuoc-thanh-tra', state: { fromNotifications: true, item: Data}}}>Bổ sung KHTT</Link>
                  </div>
                </ShowIf>
              </ShowIf> */}

              <ShowIf condition={this.props.item.keHoachThanhTraInfo === null}>
                <DeleteDialog
                  title={'Xác nhận'}
                  content={`Bạn có đồng ý xóa cuộc thanh tra này không?`}
                  redux={this.props.parent}
                  deleteId={this.props.item.cuocThanhTraId}
                  textHuy
                />
              </ShowIf>
              <ShowIf condition={this.props.item.keHoachThanhTraInfo !== null}>
                <div className="wrap-link-todo">
                  <Dialog
                    isOpen={this.state.isOpen}
                    onClose={this.closeDialog.bind(this, 'isOpen')}
                    title='Huỷ cuộc thanh tra'
                    className="dialog-them-moi-dttt dialog-default wrap-block">
                    <div className='row pl30 pr30 pt20'>
                      <Input className="col-25 mb10" label="Số công văn" placeholder="Nhập..." value={this.state.soCongVanHuyCTT} onChange={this.onChange.bind(this, 'soCongVanHuyCTT')} name='soCongVanHuyCTT' bindValidator={this} channel='formTaoDon' require/>
                      <DatePicker className="col-25 mb10" label="Ngày quyết định" value={this.state.ngayQuyetDinhHuyCTT} onChange={this.handleChangeDate.bind(this, 'ngayQuyetDinhHuyCTT')} name='ngayQuyetDinhHuyCTT' bindValidator={this} channel='formTaoDon' require/>
                      <TextArea className="col-100 mb5" label="Lý do:" value={this.state.lyDoHuyCTT} onChange={this.onChange.bind(this, 'lyDoHuyCTT')} name='lyDoHuyCTT' bindValidator={this} channel='formTaoDon' require maxLength={1000}/>
                    </div>
                    <div className='row pl35 pr35'>
                      <ContainerFileDinhKem ref='containerFileDinhKem' name='fileDinhKemHuy' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuHuyCTT} disableTopLine={true} phanLoaiQuyTrinh="HUY_CUOC_THANH_TRA" onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChangeDK.bind(this)}/>
                    </div>
                    <div className='mt10'>
                      <div className='big-border'></div>
                    </div>
                    <div className="action-form-wrap pt20">
                      <div className="box-bottom">
                        <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'isOpen')}><span>Đóng</span></Link>
                        <Link className="btn-action btn-save" onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
                      </div>
                    </div>
                  </Dialog>
                </div>
              </ShowIf>
            </div>
          </ShowIf>
        </td>
      </tr>
    );
  }
}

RowItemDanhSachCuocThanhTraPage.defaultProps = {
  validators: {
    formTaoDon: []
  }
}
export default RowItemDanhSachCuocThanhTraPage;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDanhSachCuocThanhTraPage.jsx